import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getAllRegisterStudent, verifyStudent, deleteRegisterEnquiry } from "../../services/getAdminApi";
import '../../styles/RegisterStudentList.css';
import { Delete } from "@mui/icons-material";

const RegisterStudentList = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [verifying, setVerifying] = useState({});
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await getAllRegisterStudent();
        if (response && response.data && Array.isArray(response.data.data)) {
          setStudents(response.data.data);
        } else {
          Swal.fire("Error", "Failed to fetch students data.", "error");
        }
      } catch (error) {
        console.error("Error fetching students:", error);
        Swal.fire("Error", "An error occurred while fetching the students.", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, []);

  const handleVerify = async (studentId) => {
    Swal.fire({
      title: "This cannot be undone!",
      text: "Do you want to verify and notify this student?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, verify!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setVerifying((prev) => ({ ...prev, [studentId]: true }));
          await verifyStudent(studentId);
          setStudents((prevStudents) =>
            prevStudents.map((student) =>
              student.id === studentId ? { ...student, verify: 1 } : student
            )
          );
          Swal.fire("Verified!", "The student has been verified and notified.", "success");
        } catch (error) {
          Swal.fire("Error!", "An error occurred. Please try again.", "error");
        } finally {
          setVerifying((prev) => ({ ...prev, [studentId]: false }));
        }
      }
    });
  };
  const handleDelete = (studentId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteRegisterEnquiry(studentId); // API call to delete student
          
          // Update state by removing the deleted student
          const updatedList = students.filter((student) => student.id !== studentId);
          setStudents(updatedList);
  
          Swal.fire('Deleted!', 'The student enquiry has been removed.', 'success');
        } catch (error) {
          Swal.fire('Error!', 'Failed to delete the student enquiry.', 'error');
        }
      }
    });
  };
  
  

  const handleSort = () => {
    const sortedData = [...students].sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });
    setStudents(sortedData);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  return (
    <>
      <div>
        <div className="dashboard-heading-div">
          <p>Verify Registered Students</p>
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : students.length === 0 ? (
          <p>No students found.</p>
        ) : (
          <div className="table-container-registered-students">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Gender</th>
                  <th>Nationality</th>
                  <th>City</th>
                  <th>Date & Time &nbsp;&nbsp;
                    <button onClick={handleSort}>
                      <i className="bx bxs-sort-alt" style={{ fontSize: "1rem" }}></i>
                    </button>
                  </th>
                  <th>Payment Screenshot</th>
                  <th>Payment Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {students.map((student) => (
                  <tr key={student.id}>
                    <td>{student.id}</td>
                    <td>{student.first_name}</td>
                    <td>{student.last_name}</td>
                    <td>{student.email}</td>
                    <td>{student.mobile}</td>
                    <td>{student.gender}</td>
                    <td>{student.nationality}</td>
                    <td>{student.city}</td>
                    <td>{new Date(student.created_at).toLocaleString()}</td>
                    <td>
                      {student.payment_screenshot && (
                        <a
                          href={`${"https://console.fbsedu.in/storage/app/"}/public/${student.payment_screenshot}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${"https://console.fbsedu.in/storage/app/"}/public/${student.payment_screenshot}`}
                            alt="Payment Screenshot"
                            width="50"
                            style={{ cursor: "pointer" }}
                          />
                        </a>
                      )}
                    </td>
                    <td>
                      {student.verify === 1 ? (
                        <button disabled style={{ backgroundColor: "#54d459" }} className="registed-student-verify">
                          Verified
                        </button>
                      ) : (
                        <button className="registed-student-verify"
                          onClick={() => handleVerify(student.id)}
                          disabled={verifying[student.id]}
                        >
                          {verifying[student.id] ? "Verifying..." : "Verify"}
                        </button>
                      )}
                    </td>
                    <td>
                      <button className="delete-btn" onClick={() => handleDelete(student.id)}>
                        <Delete />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default RegisterStudentList;
